import { createAction } from 'redux-actions';

export const formFinderLoad = createAction('FORMFINDER_LOAD');
export const formFinderLoaded = createAction('FORMFINDER_LOADED');
export const formFinderUnload = createAction('FORMFINDER_UNLOAD');
export const formFinderAppCreateFailed = createAction('FORMFINDER_CREATE_APPLICATION_FAILED');
